import { render, staticRenderFns } from "./IconYpoConnectLogo.vue?vue&type=template&id=6c6e4344&"
import script from "./IconYpoConnectLogo.vue?vue&type=script&lang=js&"
export * from "./IconYpoConnectLogo.vue?vue&type=script&lang=js&"
import style0 from "./IconYpoConnectLogo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports